import * as React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

const iconSpinner = <FontAwesomeIcon icon={faSpinner} size="4x" spin />

export const SpinnerBlock = () => (
    <div className="spinner-center">{iconSpinner}</div>
    );
